import { Kbd } from '@mantine/core';
import { isMac } from 'shared-base';
import { BoxPair } from '../../Guidance.types';
import { HandwrittenArrow } from '../HandwrittenArrow/HandwrittenArrow';
import Rect from '../Rect/Rect';
import { Wrapper } from './GuidanceItem.style';

export type GuidanceItemProps = {
  pair: BoxPair;
};

export function GuidanceItem(props: GuidanceItemProps) {
  const { pair } = props;
  const { target, item, arrow, guidance } = pair;
  const { title, position, className, hotkeys = [] } = item;

  function renderK(k: string, index) {
    if (k === '+') return ' + ';
    if (k === '⌥' && !isMac()) return 'Alt';

    return (
      <Kbd size='md' id={k} key={index}>
        {k}
      </Kbd>
    );
  }

  function renderKey(keys: string[]) {
    return keys.map((k, index) => renderK(k, index));
  }

  function renderKeys() {
    return hotkeys.map((keys: string[], index) => <div key={index}>{renderKey(keys)}</div>);
  }

  return (
    // Add the extra CSS class and ensure relative positioning so the arrow can be positioned absolutely
    <>
      {target && <Rect box={target} />}
      <Wrapper className={`GuidanceItem-wrapper ${className}`} data-testid='GuidanceItem-wrapper'>
        <div className='guidance-content' style={{ position: 'relative' }}>
          <Rect box={guidance}>
            <div className='guidance-title'>{title}</div>
            {hotkeys ? <div className='guidance-hotkey'>{renderKeys()}</div> : null}
          </Rect>
          <Rect box={arrow}>
            <HandwrittenArrow position={position} />
          </Rect>
        </div>
      </Wrapper>
    </>
  );
}

export default GuidanceItem;
